import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, {FC, useState, useEffect, useContext} from 'react'
import Modal from 'react-modal';
import UserService from "../../../services/UserService";
import {Context} from "../../../index";
import {useNavigate} from "react-router-dom";
import {DebounceInput} from "react-debounce-input";
import {BallTriangle} from "react-loader-spinner";

const Item: FC<any> = observer((props) => {
    const {item, setToggle} = props
    const navigate = useNavigate()

    return (
        <div className='row'>
            <hr />
            <div className="col">
                {item['type'] === 'документ' ?
                    <a href={item['url']} className="doc-link" target="_blank" rel="noreferrer" download>
                        <div className="h6 text-primary">{item['name']}</div>
                        <div>
                            <span className="small me-1"><Trans>Date</Trans>:</span>
                            <span className="small me-1">{item['date'].split('T')[0]}</span>
                            <span className="small me-1"><Trans>Type</Trans>:</span>
                            <span className="small me-1">{item['type'].split('T')[0]}</span>
                        </div>
                    </a>
                :
                    <div className="item-link">
                        <div className="h6 text-primary cursor-pointer" onClick={() => {
                            setToggle(false)
                            navigate(item['url'])
                        }}>{item['name']}</div>
                        <div>
                            <span className="small me-1"><Trans>Date</Trans>:</span>
                            <span className="small me-1">{item['date'].split('T')[0]}</span>
                            <span className="small me-1"><Trans>Type</Trans>:</span>
                            <span className="small me-1">{item['type'].split('T')[0]}</span>
                        </div>
                    </div>
                }
            </div>
        </div>

    )
});


interface ModalProps {
    toggle: boolean;
    setToggle: (value: boolean) => void;
}

export const SearchModal: FC<ModalProps> = observer(props => {
    const { toggle, setToggle } = props;
    const { store } = useContext(Context);
    const [loader, setLoader] = useState<boolean>(false);


    const findInfo = async () => {
        try {
            setLoader(true)
            const res = await UserService.getSearchedInfo({text: store.searchText})
            const list = res.data.slice().sort()
            store.setSearchData(list)
        } catch (e) {
            console.log(e)
        } finally {
            setLoader(false)
        }
    }

    useEffect(() => {
        if (document.querySelector('#floatingPassword') as HTMLInputElement) {
            (document.querySelector('#floatingPassword') as HTMLInputElement).focus()
        }
    }, []);

    // useEffect(() => {
    //     if (store.searchText.length > 2) {
    //         findInfo()
    //     }
    // }, [store.searchText]);

    const getItems = () => store.searchData.length ? store.searchData.map((item: any, i: number) => {
        return <Item key={i} {...{ item }} setToggle={setToggle}  />
    }) : null

    const onRequestClose = () => {
        setToggle(false);
    };


    return (
        <Modal isOpen={toggle} onRequestClose={onRequestClose} ariaHideApp={false}>
            <div className="row">
                <div className="col">
                    <button type='button' className='btn btn-success' onClick={() => setToggle(false)}>
                        <span className="icon close" />
                        <Trans>Close</Trans>
                    </button>
                </div>
            </div>
            <form className="Small-Modal__Body">
                <div className="input-group mb-3 p-2 justify-content-end">
                    <div className={"form-floating search-input" + (window.innerWidth > 480 ? " w-75" : "")}>
                        <DebounceInput
                            minLength={2}
                            debounceTimeout={1500}
                            className="form-control shadow-none"
                            id="floatingPassword"
                            autoFocus={true}
                            placeholder="Введите текст поиска"
                            aria-describedby="button-addon2"
                            onChange={(e) => store.setSearchText(e.target.value)}
                        />
                        <label htmlFor="floatingPassword">Введите текст поиска</label>
                    </div>
                    <span className="input-group-text cursor-pointer bg-info" onClick={() => {
                        findInfo()
                    }}>Найти</span>
                    <span className="input-group-text cursor-pointer" onClick={() => {
                        store.setSearchData([])
                        store.setSearchText('')
                    }}>X</span>
                </div>
                <div className="form-group mb-3">
                    {loader ?
                    <div className='row justify-content-center'><div className='col-md-2 mt-5'><BallTriangle color="#1d7ea7" height={90} width={90} /></div></div>
                    :
                    getItems()}
                </div>
            </form>
        </Modal >
    );
});